import {objectToQueryString} from "./Functions";


/**
 * @step 1732- helper to make http request
 */
class RequestHelper {
    static StatusMessage = {
        200: "Request Found!",
        201: "Request Found And Content Ready!",
        202: "Request Accepted This Actions take a long while to process!",
        204: "Request Accepted but No Content Here!",
        400: "Bad Request!",
        401: "Authorization Required!",
        403: "Request Forbidden!",
        404: "Request Not Found !",
        405: "Method Not Allowed!",
        406: "Not Acceptable!",
        412: "Precondition Failed!",
        422: "Unprocessable Entity",
        500: "Internal Server Error!",
    };

    /**
     * Send Request
     * @param panel
     * @param route
     * @param data
     * @param method
     * @param formData
     * @returns {Promise<{success: *, response: *}|{success: boolean, response: string}|{success: boolean, response: number}|{success: boolean, response: number}|{success: boolean, response: number}|{success: boolean, response: string}>}
     */
    static async sendRequest(panel, route, data, method, formData = false) {
        let response = {};
        let status = 200;
        let header = RequestHelper.getHeader(formData);

        const requestOptions = {
            method: method,
            headers: header,
            body: data
        };

        const path = process.env[`REACT_APP_${panel.toUpperCase()}_URL`];
        const port = process.env[`REACT_APP_${panel.toUpperCase()}_PORT`];
        const strippedUrl = path?.replace(/^https?:\/\//, '');
        // Determine if this.apiUrl is a domain or an IP address
        const isDomain = !/^\d{1,3}(\.\d{1,3}){3}$/.test(strippedUrl);

        // Construct the URL accordingly
        const url = isDomain
            ? `${path}/${port}${route}` // For domain
            : `${path}:${port}${route}`; // For IP address

        await fetch(encodeURI(url), requestOptions)
            .then(response => {
                status = response.status;
                return response.json();
            })
            .then(data => response = data)
            .catch(reason => console.log(reason));

        return RequestHelper.prepareResponse(response, status);
    }

    /**
     * Get Request
     * @param panel
     * @param route
     * @param data
     * @returns {Promise<{success: *, response: *}|{success: boolean, response: string}|{success: boolean, response: number}>}
     */
    static async get(panel, route, data = null) {
        let queryString = objectToQueryString(data);
        route += queryString;

        return await this.sendRequest(panel, route, null, 'GET');
    }

    /**
     * post request
     * @param panel
     * @param route
     * @param data
     * @returns {Promise<{success: *, response: *}|{success: boolean, response: string}|{success: boolean, response: number}>}
     */
    static async post(panel, route, data) {
        return await this.sendRequest(panel, route, JSON.stringify(data), 'POST');
    }

    /**
     * put request
     * @param panel
     * @param route
     * @param data
     * @returns {Promise<{success: *, response: *}|{success: boolean, response: string}|{success: boolean, response: number}>}
     */
    static async put(panel, route, data) {
        return await this.sendRequest(panel, route, JSON.stringify(data), 'PUT');
    }

    /**
     * delete request
     * @param panel
     * @param route
     * @param data
     * @returns {Promise<{success: *, response: *}|{success: boolean, response: string}|{success: boolean, response: number}>}
     */
    static async delete(panel, route, data) {
        return await this.sendRequest(panel, route, JSON.stringify(data), 'Delete');
    }

    /**
     * post in formdata mode
     * @param panel
     * @param route
     * @param data
     * @returns {Promise<{success: *, response: *}|{success: boolean, response: string}|{success: boolean, response: number}>}
     */
    static async postFormData(panel, route, data) {
        return await this.sendRequest(panel, route, data, 'POST', true);
    }

    /**
     * formData
     * @param formData
     * @returns {"X-Requested-With": string}
     */
    static getHeader(formData = false) {
        let auth = localStorage.getItem(`${process.env.REACT_APP_PREFIX}hybrid`);
        if (auth) {
            auth = JSON.parse(auth);
        }

        let headers = {
            'X-Requested-With': 'XMLHttpRequest',
        };
        if (!formData) {
            headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        }

        if (auth?.token) {
            headers.Authorization = `Bearer ${auth?.token}`;
        }

        return headers;
    }

    /**
     * prepare standard response
     * @param response
     * @param status
     * @returns {{success: (string|boolean|Event|*), response: *}|{success: boolean, response: string}|{success: boolean, response: number}}
     */
    static prepareResponse(response, status) {
        if (status === 200) {
            return response;
        } else if (status === 401) {
            localStorage.removeItem(process.env.REACT_APP_PREFIX + "hybrid");
            window.location.href = "/";
            return {
                success: false,
                object: response.object,
                message: response.message
            }
        } else {
            return {
                success: false,
                object: response.object,
                message: response.message
            }
        }
    }
}

export default RequestHelper;
